import {useSelector} from "react-redux";
import React from "react";
import DesktopFilter from "./DesktopFilter/Filter";
import MobileFilter from "./MobileFilter/Filter";
function Filter() {
    const isMobile = useSelector(state => state.user.isMobile)
    return isMobile ? <MobileFilter /> : <DesktopFilter />
}
export default Filter